<template>
  <div ref="indexPage" class="serverCheck">
    <!--搜索栏-->
    <common-query :query="query" @query="onClickQuery">
      <el-form-item label="收单机构">
        <common-select v-model="query.companyName" :list="companys" />
      </el-form-item>
      <el-form-item label="服务商名称">
        <el-input v-model="query.name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="服务商号">
        <el-input v-model="query.id" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="法人姓名">
        <el-input v-model="query.corpName" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="法人电话">
        <el-input v-model="query.corpPhone" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="财务对接人">
        <el-input v-model="query.financeDocker" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="注册时间" class="auto-width">
        <date-picker v-model="query.createBeginTime" />
        <span class="middle-text">至</span>
        <date-picker v-model="query.createEndTime" />
      </el-form-item>
    </common-query>

    <!-- 表格 -->
    <div class="table-list" v-loading="showLoading">
      <div class="table-content">
        <el-table
          header-cell-class-name="dark"
          :height="tableHeight"
          :data="listData"
          stripe
          border
        >
          <table-column type="index" width="60" label="序号"></table-column>
          <table-column prop="createTime" label="注册时间" />
          <table-column prop="id" label="服务商号" />
          <table-column prop="name" label="服务商名称" />
          <table-column prop="corpName" label="法人姓名" />
          <table-column prop="corpPhone" label="法人电话">
            <!-- <span slot-scope="scope">{{
              scope.row.corpPhone | hideCorpPhone
            }}</span> -->
          </table-column>
          <table-column prop="technologyDock" label="财务对接人" />
          <table-column prop="technologyPhone" label="对接人电话">
            <!-- <span slot-scope="scope">{{
              scope.row.corpPhone | hideCorpPhone
            }}</span> -->
          </table-column>
          <table-column prop="contractDueTime" label="合同有效期" />
          <table-column prop="protocolNo" label="保理协议编号" />
          <table-column prop="companyName" label="收单机构" />
          <el-table-column width="80">
            <div slot="header" class="fixed-right-column">操作</div>
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.stateAudit === 1"
                type="text"
                size="small"
                @click="handleActions(scope.row, 'edit')"
                >配置</el-button
              >
              <el-button
                v-if="scope.row.stateAudit === 4"
                type="text"
                size="small"
                @click="handleActions(scope.row, 'check')"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <common-page :page-data="pageData" @change="onChangePage" />
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight'
import queryPage from '@/mixins/queryPage'
export default {
  mixins: [mixin, queryPage],

  data() {
    return {
      // 评级
      query: {
        companyId: '', // 收单机构/管辖机构
        companyName: '', // 收单机构
        name: '', // 服务商名称
        financeDocker: '', // 财务对接人
        id: '', // 服务商号/档案号
        corpPhone: '', // 法人电话
        corpName: '', // 法人姓名
        createBeginTime: '', // 注册时间 - 开始
        createEndTime: '' // 注册时间 - 结束
      }
    }
  },

  created() {
    // 收单机构下拉列表接口
    this.getCompanyList()
  },

  methods: {
    // 修改
    handleActions({ id }, action) {
      this.$router.push({
        path: `/home/interfaceConfig/${action}`,
        query: { id }
      })
    },
    // =====请求接口数据操作=======

    // 请求列表接口
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { currentPage, pageSize }
      } = this

      return dispatch('T1/interfaceConfig/getListData', {
        ...query,
        currentPage,
        pageSize
      }).then(res => {
        if (res && res.data) {
          let { list, total } = res.data
          this.listData = list
          this.pageData.total = total
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
